import { render, staticRenderFns } from "./ElectricalSafetyManage.vue?vue&type=template&id=bec87cb2&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ElectricalSafetyManage.vue?vue&type=style&index=0&id=bec87cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec87cb2",
  null
  
)

export default component.exports